// extracted by mini-css-extract-plugin
export default {"container":"Arrow_container__ik9eH","icon":"Arrow_icon__zCQ43"};